var React = require('react');

function Yes (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_4_30)","key":0},React.createElement("path",{"d":"M21.5 5.5L8.4375 18.5L2.5 12.5909","stroke":"#008000","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_4_30"},React.createElement("rect",{"width":"24","height":"24","fill":"white"})))]);
}

Yes.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Yes;

Yes.default = Yes;
